import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

import { memoryCrudStateConfig } from "../../../consts";

const memoriesMetaInitialState = makeCrudBuilderInitialState(
  memoryCrudStateConfig
);

export default memoriesMetaInitialState;
